/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplierOrganizationMiniDto } from './SupplierOrganizationMiniDto';
import {
    SupplierOrganizationMiniDtoFromJSON,
    SupplierOrganizationMiniDtoFromJSONTyped,
    SupplierOrganizationMiniDtoToJSON,
} from './SupplierOrganizationMiniDto';

/**
 * 
 * @export
 * @interface SupplierDto
 */
export interface SupplierDto {
    /**
     * Supplier UUID
     * @type {string}
     * @memberof SupplierDto
     */
    id: string;
    /**
     * Supplier first name
     * @type {string}
     * @memberof SupplierDto
     */
    firstName: string;
    /**
     * Supplier last name
     * @type {string}
     * @memberof SupplierDto
     */
    lastName: string;
    /**
     * Supplier email
     * @type {string}
     * @memberof SupplierDto
     */
    email: string;
    /**
     * Supplier phone number
     * @type {string}
     * @memberof SupplierDto
     */
    phoneNumber: string;
    /**
     * Supplier password hash
     * @type {string}
     * @memberof SupplierDto
     */
    password: string;
    /**
     * Supplier roles array
     * @type {Array<string>}
     * @memberof SupplierDto
     */
    roles: Array<SupplierDtoRolesEnum>;
    /**
     * Flag to check if supplier is approved by admin
     * @type {boolean}
     * @memberof SupplierDto
     */
    isConfirmed: boolean;
    /**
     * Organization ID that supplier belongs to
     * @type {number}
     * @memberof SupplierDto
     */
    organizationId: number | null;
    /**
     * Supplier organization details
     * @type {SupplierOrganizationMiniDto}
     * @memberof SupplierDto
     */
    organization: SupplierOrganizationMiniDto;
    /**
     * Timestamp supplier was created at
     * @type {Date}
     * @memberof SupplierDto
     */
    createdAt: Date;
    /**
     * Timestamp supplier was updated at
     * @type {Date}
     * @memberof SupplierDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const SupplierDtoRolesEnum = {
    GlobalSupplierAdmin: 'GLOBAL_SUPPLIER_ADMIN',
    PromotionSupplierAdmin: 'PROMOTION_SUPPLIER_ADMIN',
    CatalogSupplierAdmin: 'CATALOG_SUPPLIER_ADMIN',
    OrderSupplierAdmin: 'ORDER_SUPPLIER_ADMIN',
    AddProductSupplierAdmin: 'ADD_PRODUCT_SUPPLIER_ADMIN',
    ReadOnlySupplierAdmin: 'READ_ONLY_SUPPLIER_ADMIN'
} as const;
export type SupplierDtoRolesEnum = typeof SupplierDtoRolesEnum[keyof typeof SupplierDtoRolesEnum];


/**
 * Check if a given object implements the SupplierDto interface.
 */
export function instanceOfSupplierDto(value: object): value is SupplierDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('isConfirmed' in value) || value['isConfirmed'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('organization' in value) || value['organization'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SupplierDtoFromJSON(json: any): SupplierDto {
    return SupplierDtoFromJSONTyped(json, false);
}

export function SupplierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'password': json['password'],
        'roles': json['roles'],
        'isConfirmed': json['isConfirmed'],
        'organizationId': json['organizationId'],
        'organization': SupplierOrganizationMiniDtoFromJSON(json['organization']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function SupplierDtoToJSON(value?: SupplierDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'password': value['password'],
        'roles': value['roles'],
        'isConfirmed': value['isConfirmed'],
        'organizationId': value['organizationId'],
        'organization': SupplierOrganizationMiniDtoToJSON(value['organization']),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

